import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/PreAdvise/AddHazard.css';
import addimg from '../../../Assets/TruckVisits/Assets-Desktop/add-icon.svg';
import deleteimg from '../../../Assets/TruckVisits/Assets-Desktop/delete-icon.svg';
import uncheckedimg from '../../../Assets/TruckVisits/Assets-Desktop/unchecked-box.svg';
import checked from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox-checked.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
// for redux
import { connect } from 'react-redux';
import { AES, enc } from 'crypto-js';
class AddHazard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hazarddata: [
                { id: 1, sequenceNo: "1", IMDG: "XXXXX", hazardNo: "XXXXX", UNNA: "XXXXX", propName: "XXXXX" },
                { id: 2, sequenceNo: "2", IMDG: "XXXXX", hazardNo: "XXXXX", UNNA: "XXXXX", propName: "XXXXX" }],
            hazardSelectStatus: [],
            selectedHazardsId: []
        }
    }
    handleContainer = event => {
        this.state.hazarddata?.find((hazarddata1) => {
            if (hazarddata1?.id === event + 1) {
                this.props.history.push('/home')
            }
        })
    }
    onclickAdd = () => {
        if (this.props.userProfileDataR?.userType == "Premium") {
            this.props.history.push('/CreateAddHazard', {});
        }
        if (this.props.userProfileDataR?.userType == "Preview") {
            this.props.history.push('/CreateAddHazardPreview', {});
        }
    };
    onclickDelete = () => {
        let remainingHazards = this.state.hazarddata;
        remainingHazards = remainingHazards?.filter((value, index) => {
            return this.state.selectedHazardsId?.indexOf(index) == -1;
        })
        this.setState({ hazarddata: remainingHazards, hazardSelectStatus: [] });
        console.log(this.state.hazarddata, 'inside delete hazarddata')
    };
    getSelectedHazards() {
        let selectedHazards = [];
        this.state.hazardSelectStatus?.map((val, key) => {
            if (val) {
                selectedHazards.push(key)
            }
        })
        this.setState({ selectedHazardsId: selectedHazards });
        return selectedHazards;
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.addHazardPageTitle} description={TitleDescription.addHazardPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullAddHazard">
                    <div id="csnobox1hazard">
                        <nav class="ccnononavbarhazard">
                            <div className="ccnonavbarname">
                                <small id="nonavc"> Add Hazard</small>
                            </div>
                            <div class="formobile">
                                <div class="righttopprehazard">
                                    <div class="createprehazard">
                                        <img src={addimg} id="hazardimg" height="19" width="19" class="" alt="" loading="lazy" />
                                    </div>
                                    <div class="createhazardright" onClick={this.onclickAdd}>
                                        <small id="redcreateprehazard">Add</small>
                                    </div>
                                    <div class="createprehazard">
                                        <img src={deleteimg} id="hazardimg" height="19" width="16" class="" alt="" loading="lazy" />
                                    </div>
                                    <div class="createhazardright" onClick={this.onclickDelete}>
                                        <small id={this.state.hazardSelectStatus.includes(true) ? "enabledeleteaddhazard" : "disabledeleteaddhazard"}>Delete</small>
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="formobilepart"></div>
                        <div class="addhaznotificationmaincard">
                            {(this.state.hazarddata?.map((hazarddata1, index) => {
                                return (
                                    <div class="consdiv1prehazard">
                                        <div class="checkleft">
                                            <small id="checkleft1">
                                                <img
                                                    src={this.state.hazardSelectStatus[index] ?
                                                        checked :
                                                        uncheckedimg
                                                    }
                                                    width="20"
                                                    height="20"
                                                    id="uncheckedimg"
                                                    onClick={() => {
                                                        let a = this.state.hazardSelectStatus;
                                                        a[index] = !this.state.hazardSelectStatus[index];
                                                        this.setState({ hazardSelectStatus: a }, () => {
                                                            this.getSelectedHazards()
                                                        });
                                                    }}
                                                />
                                            </small>
                                        </div>
                                        <div class="consdiv2hazard" >
                                            <div class="consdiv3hazard">
                                                <div class="cardleft1hazard">
                                                    <div class="cardleft11prehazard">
                                                        <small id="sequence">Sequence No. :</small>
                                                        <small id="sequencevalue">{hazarddata1?.sequenceNo}</small>
                                                    </div>
                                                    <div class="cardleft11prehazard">
                                                        <small id="sequence">UN/NA :</small>
                                                        <small id="sequencevalue">{hazarddata1?.UNNA}</small>
                                                    </div>
                                                </div>
                                                <div class="cardleft2prehazard">
                                                    <div class="cardleft21prehazard">
                                                        <small id="sequence">IMDG Class :</small>
                                                        <small id="sequencevalue">{hazarddata1?.IMDG}</small>
                                                    </div>
                                                    <div class="cardleft21prehazard">
                                                        <small id="sequence">Prop. Name :</small>
                                                        <small id="sequencevalue">{hazarddata1?.propName}</small>
                                                    </div>
                                                </div>
                                                <div class="cardleft3prehazard">
                                                    <small id="sequence">Hazard Number Type :</small>
                                                    <small id="sequencevalue">{hazarddata1?.hazardNo}</small>
                                                </div>
                                            </div>
                                            <div class="outerarrowbtn">
                                                <div class="consdiv12prehazard" onClick={() => this.handleContainer(index)}>
                                                    <img src={rightarrow} id="rightarrowimg" height="17" width="16" class="" alt="" loading="lazy" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>);
                            }))}
                        </div>
                        <div class="okbttnplacardhazard">
                            <div class="btttndivvhazard">
                                <Button class={this.state.hazarddata?.length == 0 ? "buttondisplayoff" : "bttplacardhazard"}>
                                    <small id="placardokhazard"> OK</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(AddHazard);